var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDrawWalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "element_icon_24_menu_alternate_copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exhibify_draw_walls_icon",
    transform: "translate(3 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2,0A2,2,0,1,0,4,2,2,2,0,0,0,2,0Z",
    transform: "translate(4 11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 6,
    height: 2,
    rx: 1,
    transform: "translate(0 12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M13,1a1,1,0,0,0-1-1H1A1,1,0,0,0,0,1V13a1,1,0,0,0,2,0V2H12A1,1,0,0,0,13,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M10.716.3A1,1,0,0,0,9.3.3l-9,9a1,1,0,0,0,.71,1.71,1,1,0,0,0,.71-.29l9-9a1,1,0,0,0,0-1.42Z",
    transform: "translate(8)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrawWalls);
export default __webpack_public_path__ + "static/media/icon-draw-walls.23e16ae1a58fed64237b6ab89fb12d83.svg";
export { ForwardRef as ReactComponent };